import { render, staticRenderFns } from "./vSettingDropdown.vue?vue&type=template&id=0b9e3af0&"
import script from "./vSettingDropdown.vue?vue&type=script&lang=js&"
export * from "./vSettingDropdown.vue?vue&type=script&lang=js&"
import style0 from "./vSettingDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports